import {
  limitedReleaseByPhysicalConstants,
  createLimitedReleaseByPhysicalConstants,
  editLimitedReleaseByPhysicalConstants,
  activateLimitedReleaseByPhysicalConstants,
  deactivateLimitedReleaseByPhysicalConstants,
  deleteLimitedReleaseByPhysicalConstants,
} from "../_redux-constants";
import { limitedReleasesPhysicalService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getLimitedReleaseByPhysical(queryParams) {
  function getLimitedReleaseByPhysicalLoad() {
    return {
      type: limitedReleaseByPhysicalConstants.LIMITED_RELEASE_BY_PHYSICAL_LOADING,
    };
  }
  function getLimitedReleaseByPhysicalSuccess(data) {
    return {
      type: limitedReleaseByPhysicalConstants.LIMITED_RELEASE_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function getLimitedReleaseByPhysicalFailure(error) {
    return {
      type: limitedReleaseByPhysicalConstants.LIMITED_RELEASE_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getLimitedReleaseByPhysicalLoad());
    return limitedReleasesPhysicalService
      .getLimitedReleaseByPhysical(queryParams)
      .then(
        (data) => {
          dispatch(getLimitedReleaseByPhysicalSuccess(data));
        },
        (error) => {
          dispatch(getLimitedReleaseByPhysicalFailure(error?.toString()));
        }
      );
  };
}

function createLimitedReleaseByPhysical(requestBody, queryParams) {
  function createLimitedReleaseByPhysicalLoad() {
    return {
      type: createLimitedReleaseByPhysicalConstants.CREATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING,
    };
  }
  function createLimitedReleaseByPhysicalSuccess(data) {
    return {
      type: createLimitedReleaseByPhysicalConstants.CREATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function createLimitedReleaseByPhysicalFailure(error) {
    return {
      type: createLimitedReleaseByPhysicalConstants.CREATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createLimitedReleaseByPhysicalLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesPhysicalService
        .createLimitedReleaseByPhysical(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createLimitedReleaseByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createLimitedReleaseByPhysicalFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editLimitedReleaseByPhysical(requestBody, queryParams) {
  function editLimitedReleaseByPhysicalLoad() {
    return {
      type: editLimitedReleaseByPhysicalConstants.EDIT_LIMITED_RELEASE_BY_PHYSICAL_LOADING,
    };
  }
  function editLimitedReleaseByPhysicalSuccess(data) {
    return {
      type: editLimitedReleaseByPhysicalConstants.EDIT_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function editLimitedReleaseByPhysicalFailure(error) {
    return {
      type: editLimitedReleaseByPhysicalConstants.EDIT_LIMITED_RELEASE_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editLimitedReleaseByPhysicalLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesPhysicalService
        .editLimitedReleaseByPhysical(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editLimitedReleaseByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editLimitedReleaseByPhysicalFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateLimitedReleaseByPhysical(queryParams) {
  function activateLimitedReleaseByPhysicalLoad() {
    return {
      type: activateLimitedReleaseByPhysicalConstants.ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING,
    };
  }
  function activateLimitedReleaseByPhysicalSuccess(data) {
    return {
      type: activateLimitedReleaseByPhysicalConstants.ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function activateLimitedReleaseByPhysicalFailure(error) {
    return {
      type: activateLimitedReleaseByPhysicalConstants.ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateLimitedReleaseByPhysicalLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesPhysicalService
        .activateLimitedReleaseByPhysical(queryParams)
        .then(
          (data) => {
            dispatch(activateLimitedReleaseByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              activateLimitedReleaseByPhysicalFailure(error?.toString())
            );
            reject(error);
          }
        );
    });
  };
}

function deactivateLimitedReleaseByPhysical(queryParams) {
  function deactivateLimitedReleaseByPhysicalLoad() {
    return {
      type: deactivateLimitedReleaseByPhysicalConstants.DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING,
    };
  }
  function deactivateLimitedReleaseByPhysicalSuccess(data) {
    return {
      type: deactivateLimitedReleaseByPhysicalConstants.DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function deactivateLimitedReleaseByPhysicalFailure(error) {
    return {
      type: deactivateLimitedReleaseByPhysicalConstants.DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateLimitedReleaseByPhysicalLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesPhysicalService
        .deactivateLimitedReleaseByPhysical(queryParams)
        .then(
          (data) => {
            dispatch(deactivateLimitedReleaseByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateLimitedReleaseByPhysicalFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteLimitedReleaseByPhysical(queryParams) {
  function deleteLimitedReleaseByPhysicalLoad() {
    return {
      type: deleteLimitedReleaseByPhysicalConstants.DELETE_LIMITED_RELEASE_BY_PHYSICAL_LOADING,
    };
  }
  function deleteLimitedReleaseByPhysicalSuccess(data) {
    return {
      type: deleteLimitedReleaseByPhysicalConstants.DELETE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS,
      data,
    };
  }
  function deleteLimitedReleaseByPhysicalFailure(error) {
    return {
      type: deleteLimitedReleaseByPhysicalConstants.DELETE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteLimitedReleaseByPhysicalLoad());
    return new Promise((resolve, reject) => {
      limitedReleasesPhysicalService
        .deleteLimitedReleaseByPhysical(queryParams)
        .then(
          (data) => {
            dispatch(deleteLimitedReleaseByPhysicalSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteLimitedReleaseByPhysicalFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const limitedReleasesPhysicalActions = {
  getLimitedReleaseByPhysical,
  createLimitedReleaseByPhysical,
  editLimitedReleaseByPhysical,
  activateLimitedReleaseByPhysical,
  deactivateLimitedReleaseByPhysical,
  deleteLimitedReleaseByPhysical,
};
